var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.32 15.3787L10.8568 21.8935C11.5195 21.8935 11.8065 21.6088 12.1507 21.267L15.2576 18.2977L21.6954 23.0124C22.8761 23.6704 23.7079 23.3239 24.0265 21.9262L28.2522 2.12502L28.2534 2.12386C28.6279 0.378482 27.6222 -0.304034 26.4718 0.124143L1.63291 9.63387C-0.0622942 10.2919 -0.0366269 11.2369 1.34474 11.6651L7.69506 13.6403L22.4456 4.41058C23.1398 3.9509 23.7709 4.20524 23.2518 4.66492L11.32 15.3787Z",
    fill: "#A2ADB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.d397b971079ecfa329a01e8b8af7d70c.svg";
export { ForwardRef as ReactComponent };